import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { useAuthValue } from '../context/AuthContext';
import GenericError from '../routes/GenericError';
import { MemoizeLogin } from '../routes/Login';
import NotFound from '../routes/NotFound';
import RecoverPass from '../routes/RecoverPass';
import Register from '../routes/Register';
import SelectOrganization from '../routes/SelectOrganization';
import VerificationSuccess from '../routes/VerificationSuccess';
import VerifyChangedEmail from '../routes/VerifyChangedEmail';
import VerifyEmail from '../routes/VerifyEmail';
import { isFleetcare, isMindy, isOms, isStork } from '../utils';

// Override variables with stork as the primary theme
if (isStork) {
    import('../../../../libs/tailwind-preset/stork.variables.css');
}

// Override variables with mindy as the primary theme
if (isMindy) {
    import('../../../../libs/tailwind-preset/mindy.variables.css');
}

// Override variables with fleetcare as the primary theme
if (isFleetcare) {
    import('../../../../libs/tailwind-preset/fleetcare.variables.css');
}

// Override variables with oms as the primary theme (blue)
if (isOms) {
    import('../../../../libs/tailwind-preset/oms.variables.css');
}

export function App() {
    const context = useAuthValue();
    const location = useLocation();

    const currentUser = context?.idpUser;

    // Component to redirect to login while preserving query parameters
    const RedirectToLogin = () => {
        const queryString = location.search;
        return <Navigate to={`/login${queryString}`} replace />;
    };

    return (
        <Routes>
            <Route path="/" element={<RedirectToLogin />} />
            <Route path="/select-organization" element={<SelectOrganization />} />
            <Route path="/login" element={<MemoizeLogin />} />
            <Route
                path="/register"
                element={!currentUser?.emailVerified ? <Register /> : <Navigate to={`/${location.search}`} replace />}
            />
            <Route path="/verify-changed-email" element={<VerifyChangedEmail />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verification-success" element={<VerificationSuccess />} />
            <Route path="/error" element={<GenericError />} />
            <Route path="/recover-password" element={<RecoverPass />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default App;
